import { actionTypes } from '@/core/constants'
import SignatariosDocumentoAnexosApiClient from '@/core/apiclient/documentos/signatarios/SignatariosDocumentoAnexosApiClient'
import DocumentosUrlBuilder from '@/core/utils/factory/documentos/DocumentosUrlBuilder'

function createApiClient(tipo) {
	const urlBuilder = new DocumentosUrlBuilder(tipo)
	return new SignatariosDocumentoAnexosApiClient(urlBuilder)
}

export default {
	async [actionTypes.DOCUMENTOS.SIGNATARIOS.CONVIDAR_SIGNATARIOS](context, objConvidar) {
		const apiClient = createApiClient(objConvidar.tipo)
		const { data } = await apiClient.convidarSignatariosDocumentoAnexos(
			objConvidar.idDocumento,
			objConvidar.emailsSignatarios,
		)
		return data
	},

	async [actionTypes.DOCUMENTOS.SIGNATARIOS.EXCLUIR](context, objExcluir) {
		const apiClient = createApiClient(objExcluir.tipo)
		const { data } = await apiClient.excluirSignatariosDocumentoAnexos(
			objExcluir.idDocumento,
			objExcluir.emailsSignatarios,
		)
		return data
	},

	async [actionTypes.DOCUMENTOS.SIGNATARIOS.BUSCAR_SIGNATARIOS](context, objBuscar) {
		const apiClient = createApiClient(objBuscar.tipo)
		const { data } = await apiClient.buscarSignatariosDocumentoAnexos(objBuscar.idDocumento)
		return data
	},
}
